import { account } from '@/plugins'

export default {
  authenticated (to, from, next) {
    // console.log('[Middleware for ' + to.path + '] is authenticated ?', account.isAuthenticated)
    if(account.isAuthenticated) {
      next(true)
    } else {
      next('/login')
    }
  },
  verified (to, from, next) {
    // console.log('[Middleware for ' + to.path + '] is verified ?', account.isVerified)
    if(account.isVerified) {
      next(true)
    } else {
      next('/verify')
    }
  },
  administrator (to, from, next) {
    next(account.isAdministrator)
  },
}